// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton-module--back-button--2BEI0","text":"BackButton-module--text--12Zbs","icon":"BackButton-module--icon--z_-hM"};